export default "__VITE_ASSET__57c2f6ec__"